import {MultiChoice} from 'platform/components';

import i18n from '@dms/i18n';

import {suffixTestId, TestIdProps} from 'shared/web';

import {useTrimLevelOptions} from '../../../../../hooks/useTrimLevelOptions';
import {useFilters} from '../../../../FiltersContext/FiltersContext';

export function TrimLevelFilter(props: TestIdProps & {isCompact?: boolean}) {
  const {filters, onUpdateFilters} = useFilters();
  const {options, hasMake, isLoading, isError} = useTrimLevelOptions();
  return (
    <MultiChoice
      noOptionsMessage={() => i18n.t('general.labels.noOptions')}
      label={i18n.t('entity.vehicle.labels.featureTiers')}
      options={options}
      value={filters.trimLevels ?? null}
      onChange={(value) => onUpdateFilters('trimLevels', value?.length ? value : undefined)}
      menuInPortal={props.isCompact}
      isLoading={isLoading}
      helperText={hasMake ? undefined : i18n.t('page.filters.notifications.firstSelectMakes')}
      isDisabled={!hasMake && !filters.trimLevels?.length}
      errorMessage={isError ? i18n.t('general.errors.cannotLoadOptions') : undefined}
      data-testid={suffixTestId('trimLevels', props)}
    />
  );
}
